import { createWebRegistration } from '@reflex/plugin-api/create-web-registration';

export default createWebRegistration({});
